import {css} from 'lit';
export const styles = css`:host{display:none;overflow:hidden;will-change:height}:host([expanded]){display:block;position:relative}:host([fixed]){overflow-y:auto}.body{position:relative;overflow:hidden}.body:after{content:"";position:absolute;top:0;bottom:0;left:0}`;
export default styles;
